const guide = {
    start_building: 'Bắt đầu xây dựng',
    get_started: 'Bắt đầu',
    categories: {
        featured: 'Phổ biến và dành cho bạn',
        Traditional: 'Ứng dụng web truyền thống',
        SPA: 'Ứng dụng một trang',
        Native: 'Ứng dụng native',
        MachineToMachine: 'Máy-đến-máy',
        Protected: 'Tích hợp không dùng SDK',
        ThirdParty: 'Ứng dụng bên thứ ba',
        SAML: 'Ứng dụng SAML',
    },
    filter: {
        title: 'Lọc theo framework',
        placeholder: 'Tìm kiếm framework',
    },
    checkout_tutorial: 'Xem hướng dẫn {{name}}',
    do_not_need_tutorial: "Nếu bạn không cần hướng dẫn, bạn có thể tiếp tục mà không cần hướng dẫn theo framework",
    finish_and_done: 'Hoàn tất',
    cannot_find_guide: "Không tìm thấy hướng dẫn bạn cần?",
    describe_guide_looking_for: 'Mô tả hướng dẫn bạn đang tìm',
    request_guide_successfully: 'Yêu cầu của bạn đã được gửi thành công. Xin cảm ơn!',
    app: {
        select_framework_or_tutorial: 'Chọn một framework hoặc hướng dẫn',
        guide_modal_title: 'Bắt đầu với SDK và hướng dẫn',
        modal_subtitle: 'Khởi động nhanh quá trình phát triển ứng dụng của bạn với SDK và hướng dẫn có sẵn của chúng tôi.',
        select_a_framework: 'Chọn một framework',
        continue_without_framework: 'Tạo ứng dụng không dùng framework',
        describe_guide_looking_for_placeholder: 'Ví dụ: Tôi muốn tích hợp sdvico vào ứng dụng Angular của mình.',
    },
    api: {
        modal_title: 'Bắt đầu với hướng dẫn',
        modal_subtitle: 'Khởi động nhanh quá trình phát triển ứng dụng của bạn với các hướng dẫn có sẵn của chúng tôi.',
        select_a_tutorial: 'Chọn một hướng dẫn',
        continue_without_tutorial: 'Tiếp tục không cần hướng dẫn',
        describe_guide_looking_for_placeholder: 'Ví dụ: Tôi muốn bảo vệ API của mình bằng deno.',
    },
};
export default Object.freeze(guide);
